import { api } from "@/lib/api";

const usd = (v) => `US$${(+v).toFixed(2)}`;

// Asks for confirmation with a rough OpenRouter cost; resolves true when the user agrees.
export const confirmWithCost = async (pid, params, question) => {
  let line = "";
  try {
    const { data: e } = await api.get(`/products/${pid}/estimate`, { params });
    const each = e.count ? e.estimate / e.count : 0;
    line = `\n\nEstimated OpenRouter cost: about ${usd(e.estimate)} (${usd(e.low)}–${usd(e.high)})`
      + `\n${e.count} ${e.unit}${e.count === 1 ? "" : "s"} × ~${usd(each)} with ${e.model}`
      + (e.credit_left != null ? `\nCredit left: ${usd(e.credit_left)}` : "");
    if (e.credit_left != null && e.high > e.credit_left) line += "\n\n⚠ This may use more than the credit you have left.";
  } catch {
    line = "\n\n(Couldn't estimate the cost right now.)";
  }
  return window.confirm(question + line);
};
